export default __webpack_public_path__ + "static/media/about-hero-1.d45d3233.png";